import { render, staticRenderFns } from "./list.vue?vue&type=template&id=a32bc5da&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32bc5da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a32bc5da')) {
      api.createRecord('a32bc5da', component.options)
    } else {
      api.reload('a32bc5da', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=a32bc5da&scoped=true", function () {
      api.rerender('a32bc5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/furlough/list.vue"
export default component.exports